/// <amd-module name="Environments/Providers/Kubernetes/Generated/TaskAgentClient/TaskAgent" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\web\extensions\environments\vss-environments-web\providers\kubernetes\k8s.taskagent.genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

export interface ITaskAgentRestClient extends IVssRestClient {
    /**
     * @param project - Project ID or project name
     * @param environmentId - 
     * @param resourceId - 
     */
    deleteKubernetesResource(project: string, environmentId: number, resourceId: number): Promise<void>;
}

class TaskAgentRestClient extends RestClientBase implements ITaskAgentRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * @param project - Project ID or project name
     * @param environmentId - 
     * @param resourceId - 
     */
    public async deleteKubernetesResource(
        project: string,
        environmentId: number,
        resourceId: number
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "5.0-preview.1",
            method: "DELETE",
            routeTemplate: "{project}/_apis/distributedtask/environments/{environmentId}/providers/kubernetes/{resourceId}",
            routeValues: {
                project: project,
                environmentId: environmentId,
                resourceId: resourceId
            }
        });
    }

}

export const TaskAgentClientName = "k8s.taskagent.client.ITaskAgentRestClient";

export function getTaskAgentClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): ITaskAgentRestClient {
    return pageContext.getRestClient<ITaskAgentRestClient>(TaskAgentClientName, options);
}

RestClients.add(TaskAgentClientName, { 
    factory: TaskAgentRestClient,
    options: {
        resourceAreaId: "a85b8835-c1a1-4aac-ae97-1c3d0ba72dbd",
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
